import { render, staticRenderFns } from "./USSD.vue?vue&type=template&id=0ab8afe9&"
import script from "./USSD.vue?vue&type=script&lang=js&"
export * from "./USSD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports